import React, { useCallback, useContext } from "react";
import styled from "styled-components";
import Cookies from "universal-cookie";
import AuthLayout from "../layouts/Auth.layout";
import { MainContext } from "../context/MainContext";
import fetchService from "../utils/fetch.service";
import TelegramLoginButton from "../components/TelegramAuth";
import DATA from "../const/data";

const cookies = new Cookies();

const Card = styled.section`
    width: 100%;
    padding: 24px 20px;
    border: 1px solid var(--line-strong);
    border-radius: var(--radius-lg);
    background: rgba(17, 27, 43, 0.78);

    .eyebrow {
        margin: 0 0 10px;
        color: var(--accent);
        font-size: 11px;
        font-weight: 750;
        letter-spacing: 0.15em;
        text-transform: uppercase;
    }

    h1 {
        margin: 0;
        font-family: Georgia, "Times New Roman", serif;
        font-size: clamp(38px, 11vw, 54px);
        line-height: 1;
        letter-spacing: -0.05em;
    }

    > p {
        margin: 14px 0 0;
        color: var(--text-soft);
        font-size: 15px;
    }

    @media (min-width: 768px) {
        padding: 36px;
    }
`;

const LoginArea = styled.div`
    min-height: 104px;
    margin-top: 26px;
    padding: 24px 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-top: 1px solid var(--line);
    border-bottom: 1px solid var(--line);
`;

const BetaNote = styled.p`
    color: var(--muted) !important;
    font-size: 13px !important;
`;

const AuthPage = () => {
    document.title = `Login${ DATA.websiteTitle }`;
    const { userContext, isLoggedContext } = useContext(MainContext);
    const [, setUser] = userContext;
    const [, setIsLogged] = isLoggedContext;

    const onTelegramAuth = useCallback(async (user) => {
        fetchService.post("/auth", user).then((res) => {
            cookies.set("tpir", res.token, { path: "/", expires: new Date(Date.now() + 25920000000) });
            if (res.user) {
                setUser(res.user);
                setIsLogged(true);
            }
        }).catch((error) => console.log(error));
    }, [setIsLogged, setUser]);

    return (
        <AuthLayout>
            <Card>
                <p className="eyebrow">Real people. Real conversations.</p>
                <h1>Meet someone on Telegram</h1>
                <p>Sign in securely with Telegram to set up your profile and find people to chat with.</p>
                <LoginArea>
                    <TelegramLoginButton dataOnauth={ onTelegramAuth } botName="tele_sex_chat_bot" buttonSize="large"/>
                </LoginArea>
                <BetaNote>This app is in beta, so matches may be limited while we keep improving it.</BetaNote>
            </Card>
        </AuthLayout>
    );
};

export default AuthPage;
